import { IDeal } from '../../types'
import { TApiDeals } from '../../../services/moneyFlow/types'

export function parseDeals(response: TApiDeals): IDeal[] {
    return response.entities.map((item) => ({
        id: item['@id'],
        name: item.name,
    }))
}